import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Car } from '@/types';
import { useDeleteCarMutation } from '@/services';

export interface DeleteCarProps extends DialogProps {
  car: Car;
  onClose(): void;
}

const DeleteCar: React.FC<DeleteCarProps> = ({ car, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteCar, deleteCarResponse] = useDeleteCarMutation();

  async function handleDeleteCar() {
    try {
      await deleteCar(car).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{car?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{car?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="outlined" disabled={deleteCarResponse.isLoading} onClick={onClose}>
          Закрыть
        </Button>

        <Button variant="contained" disabled={deleteCarResponse.isLoading} onClick={handleDeleteCar}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCar;
